export default __webpack_public_path__ + "static/media/Duffel1.fbae81fb.jpg";